import { createContext, PropsWithChildren, RefObject, useContext, useRef } from "react";

type MenuButtonContainerContextType = {
  containerRef: RefObject<Element>;
};

const MenuButtonContainerContext = createContext<MenuButtonContainerContextType>({} as MenuButtonContainerContextType);

export const MenuButtonContainerProvider = ({ children }: PropsWithChildren<{}>) => {
  const containerRef = useRef<Element>(null);

  return (
    <MenuButtonContainerContext.Provider
      value={{
        containerRef
      }}
    >
      {children}
    </MenuButtonContainerContext.Provider>
  );
};

export const useMenuButtonContainer = () => {
  const menuButtonContainerState = useContext(MenuButtonContainerContext);
  if (menuButtonContainerState === null) {
    throw new Error("useMenuButtonContainer must be used within an MenuButtonContainerProvider");
  }

  return menuButtonContainerState;
};